import { render, staticRenderFns } from "./StatisticDetails.vue?vue&type=template&id=a690ebdc&scoped=true&"
import script from "./StatisticDetails.vue?vue&type=script&lang=js&"
export * from "./StatisticDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatisticDetails.vue?vue&type=style&index=0&id=a690ebdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a690ebdc",
  null
  
)

export default component.exports